import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

export const useLoadingStore = defineStore('loadingStore', () => {
  const { t } = useI18n()
  const loading = ref<boolean>(true)
  const loadingTexts = ref<string[] | []>([])
  const loadingOverLoaderTexts = ref<string[] | []>([])
  const loadingIcon = ref<string>()
  const loadHeader = ref<boolean>(true)
  const mock = ref<boolean>(false)

  function startLoading(...texts: string[]) {
    if (loading.value) return

    loading.value = true
    if (!texts) return

    loadingTexts.value = texts.map((text) => t(text))
  }

  function startLoadingWithOptions({
    texts,
    overLoaderTexts,
    icon
  }: {
    texts?: string[]
    overLoaderTexts?: string[]
    icon?: string
  }) {
    if (loading.value) return

    loading.value = true
    loadingTexts.value = texts?.map((text) => t(text)) ?? []

    loadingOverLoaderTexts.value = overLoaderTexts?.map((text) => t(text)) ?? []

    loadingIcon.value = icon
  }

  function stopLoading() {
    loading.value = false
  }

  function isLoading() {
    return loading.value
  }

  function getLoadingTexts(): string[] {
    return loadingTexts.value
  }

  function getOverLoaderTexts(): string[] {
    return loadingOverLoaderTexts.value
  }

  function getIcon(): string | undefined {
    return loadingIcon.value
  }

  function hideHeader() {
    loadHeader.value = false
  }
  function activeMock() {
    mock.value = true
  }
  function isActiveMock() {
    return mock.value
  }

  return {
    isLoading,
    startLoading,
    startLoadingWithOptions,
    stopLoading,
    getOverLoaderTexts,
    getIcon,
    getLoadingTexts,
    hideHeader,
    loadHeader,
    activeMock,
    isActiveMock
  }
})
